"use client";
import React from "react";
import { ArrowLeft } from "lucide-react";
export default function BlogBackButton() {
  return (
    <ArrowLeft
      className="cursor-pointer mb-6 absolute top-6 left-6"
      size={24}
      onClick={() => window.history.back()}
    />
  );
}
